module.exports = __webpack_public_path__ + "media/images/application/template/arrow-down-174d64c9021a138bda30764e03960b2d.svg";